var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.157 32.0531C27.7792 32.2892 27.3542 32.3836 26.9764 32.3836C26.5986 32.3836 26.1736 32.2892 25.7957 32.0531L7 20.5773V35.8311C7 39.0897 9.64463 41.7343 12.9032 41.7343H41.0968C44.3554 41.7343 47 39.0897 47 35.8311V20.5773L28.157 32.0531Z",
    fill: "#F96619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0966 12.2656H12.9029C10.1166 12.2656 7.75537 14.2491 7.18866 16.8937L27.0234 28.9835L46.8109 16.8937C46.2441 14.2491 43.8829 12.2656 41.0966 12.2656Z",
    fill: "#F96619"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/ic_email.97ebe05b6e1bf8be2b9d72b77dc2c692.svg";
export { ForwardRef as ReactComponent };